<template>
  <div>
    <v-date-picker
      v-model='selectedDate'
      :is-inline='true'
      :theme-styles='caldendarThemeStyles'
      :tint-color="channelColor"
    />

    <!-- <input type="checkbox" name="" id="">multidate -->
  </div>
</template>

<script>
export default {
  data () {
    return {
      caldendarThemeStyles: {
        wrapper: {
          background: '#FFF',
          color: '#888',
          padding: '10px'
        }
      }
    }
  },

  computed: {
    selectedDate: {
      get () {
        return this.$store.state.date
      },

      set (date) {
        this.$store.dispatch('fetchData', { date })
      }
    },
    channelColor () {
      switch (this.$store.state.channel.value) {
        case 'main':
          return '#008DCB'
        case 'proc':
          return '#b0151e'
        case 'dare':
          return '#78408e'
        case 'int':
          return '#008DCB'
        case 'canada':
          return '#ED1C24'
        case 'kids':
          return '#fed32f'
        case 'lat':
          return '#ef5e2f'
        case 'praise':
          return '#FCB424'
        case 'radio':
          return '#047C7C'
      }
    }
  }
}
</script>

<style>

.c-pane {
  font-family: 'Open Sans', sans-serif;
}

.c-day {
  padding: 0 6px;
}
.c-day-content {
  font-size: 12px !important;
  font-weight: 700 !important;
}
</style>
